<template>
	<v-card flat max-width="950px" class="mx-auto transparent">
        <HeadRoot 
            title="Molecule"
            :length="0"
            btn_txt=""
            btn_to="" />
        
        <div class="mt-4">
            <v-img :src="require('@/assets/banners/molecule.png')"></v-img>
        </div>

        <div class="pb-4" style="margin-top:30px" v-if="loaded">
            <div class="text-center mr-5">
                <v-btn text  @click="$router.push('/captain-profile/'+uid)" :style="{color: color}" v-if="role.captain">
                    <v-icon size="14px" :color="color" left>fa-angle-left</v-icon>
                    Back to {{name}} profile
                </v-btn>
                <v-btn text  @click="$router.push('/profile/'+uid)" :style="{color: color}" v-if="role.student">
                    <v-icon size="14px" :color="color" left>fa-angle-left</v-icon>
                    Back to {{name}} profile
                </v-btn>
            </div>

            <!-- <div ref="central" class="central mt-8" style="margin-left:-150px">
                <Central :photo="photo" :name="name" :attributes="attributes" />
            </div> -->

            <div class="d-flex justify-center mt-6" v-if="!user.role.student">
                <v-btn class="bMolecule white--text mx-1" @click="zoomIn" :disabled="zoomin">
                    <v-icon small color="white" left>fa-search-plus</v-icon>
                    Zoom in
                </v-btn>
                <v-btn class="bMolecule white--text mx-1" @click="zoomOut" :disabled="!zoomin">
                    <v-icon small color="white" left>fa-search-plus</v-icon>
                    Zoom out
                </v-btn>
            </div>

            <div class="d-flex justify-center pb-4" style="margin-top:65px" :class="{'righty': user.role.student}">
                <div ref="central" class="central">
                    <Central :photo="photo" :name="name" :attributes="attributes" />
                </div>
                <div ref="extended" class="extended" v-if="!user.role.student">
                    <Extended :concepts="concepts" />
                </div>
            </div>
        </div>

        <SendingLoader v-else />
	</v-card>
</template>

<script>
import { gsap, timeline } from 'gsap'
import Helpers from '@/services/helpers'
import Central from '@/components/molecule/Central'
import Users from '@/firebase/users'
import Extended from '@/components/molecule/Extended'

export default {
    data: () => ({
        loaded: false,
        uid: '',
        name: '',
        attributes: '',
        concepts: '',
        team: '',
        color: '',
        role: {},
        zoomin: false,
        esta: null
    }),
    components: {
        Central,
        Extended
    },
    mounted() {
        //this.esta = gsap.timeline();
        this.init();
    },
    // watch: {
    //     loaded() {
    //         if (this.loaded) {
    //             setTimeout(() => {
    //                 this.esta.fromTo(this.$refs['central'], 1.8,{ webkitFilter: "brightness(1)", filter: "brightness(1)" },
    //                         {
    //                             webkitFilter: "brightness(1.5)",
    //                             filter: "brightness(1.5)",
    //                             yoyo: true,
    //                             repeat: -1,
    //                             repeatDelay: 1.5,
    //                             ease:'Linear.easeNone'
    //                         }
    //                     );
    //             }, 1);
    //         }
    //     }
    // },
    methods: {
        init() {
            Users.get(this.$route.params.id)
                    .then(response => {
                        if (response.status === true) {
                            this.uid = response.doc.id;
                            this.name = response.doc.data().name;
                            this.photo = response.doc.data().photo;
                            this.attributes = response.doc.data().attributes;
                            this.concepts = response.doc.data().concepts;
                            this.team = response.doc.data().team;
                            this.color = response.doc.data().color;
                            this.role = response.doc.data().role;
                            this.loaded = true;
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'Error.'});
                        }
                    });
        },
        zoomIn() {
            gsap.fromTo(this.$refs['central'], {opacity:1 }, {y:-12, x:-12, scaleX: .4, scaleY: .4, duration:1.2, ease:'circ.out' });
            gsap.fromTo(this.$refs['extended'], {opacity:0 }, {opacity:1, duration:1.2, delay:.6, ease:'circ.out' });
            this.zoomin = true;
            // this.esta.pause();
        },
        zoomOut() {
            gsap.fromTo(this.$refs['central'], {opacity:1 }, {y:-12, x:-12, scaleX: 1, scaleY: 1, duration:1.2, delay:.4, ease:'circ.out' });
            gsap.fromTo(this.$refs['extended'], {opacity:1 }, {opacity:0, duration:1.2, ease:'circ.out' });
            this.zoomin = false;
            // setTimeout(() => {
            //     this.esta.resume();
            // }, 1000);
        },
    }
}
</script>

<style scoped>
    .central {
        position:relative;
        left:300px;
    }
    .extended {
        position:relative;
        opacity: 0;
        left:-290px;
        top:-51px;
    }
    .righty {
        margin-right: 550px;
    }
</style>

